












































































































import {Component, Prop, Ref, Vue, Watch} from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import {cloneDeep, isEqual} from "lodash";
import { SelectWings } from "wings-ui-components";
import { notifyConfirm, notifyDelete, notifyError } from "@/utils/notify-helper";
import {PriorityRuleItem, PriorityRuleItemImpl} from "@/store/rules/priority_rules/types";
import {OriginatorItem} from "@/store/settings/originators/types";
import {TemplateItem} from "@/store/sms/templates/types";
import {MsgTransports} from "@/store/types";
import {ActionLog} from "@/store/auth/types";
import {getTranslatedParams} from "@/utils/notify-utils";

@Component({components: { SelectWings }})
export default class PriorityRule extends Vue {
  @Ref('validator') validator:any;
  @Prop() transport!: MsgTransports;
  @Getter("priorityList") priorityList: any;
  @Action("getPartners") actionGetPartners: any;
  @Action("getOriginators") actionGetOriginators: any;
  @Action("getSmsTemplates") actionGetSmsTemplates: any;
  @Action("getPriorityRuleItem") actionGetItem: any;
  @Action("savePriorityRule") actionSave: any;
  @Action("deletePriorityRule") actionDelete: any;
  @Action("actionLog") actionLog: any;

  private item:PriorityRuleItem = new PriorityRuleItemImpl();
  private itemSaved:PriorityRuleItem = new PriorityRuleItemImpl();
  private logObject: ActionLog = {};

  params = {transport: this.transport};
  partnersList: any = []
  originatorsList: any = []
  smsTemplatesList:  any = []

  async getPartnersList(filter: any) {
    const items = await this.actionGetPartners({...this.params, ...filter});
    this.partnersList = (filter?.page_number > 1) ? this.partnersList.concat(items) : items
  }

  async getOriginatorsList(filter: any) {
    const items = await this.actionGetOriginators({partner_id: this.item.partner_id, ...this.params, ...filter});
    this.originatorsList = (filter?.page_number > 1) ? this.originatorsList.concat(items) : items
  }

  async getSmsTemplatesList(filter: any) {
    const items = await this.actionGetSmsTemplates({partner_id: this.item.partner_id, is_active: 1, ...filter});
    this.smsTemplatesList = (filter?.page_number > 1) ? this.smsTemplatesList.concat(items) : items
  }

  async created() {
    if (this.$route.params.id) {
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Viewing",
          action_status: "success",
          object_type: "The rule for changing the priority of sending",
          addititional_info: getTranslatedParams(this.item)
        }
        const data = await this.actionGetItem({
          id: this.$route.params.id,
          transport: this.transport.toLowerCase()
        })
        await this.actionLog(this.logObject);
        this.item = Object.assign({},this.item, data);
        this.itemSaved = cloneDeep(Object.assign({},this.item, data));
      } catch (error) {
        this.actionLog({...this.logObject, action_status: "failed"});
      }
      this.partnersList = await this.actionGetPartners({id: this.item.partner_id});
      this.originatorsList = await this.actionGetOriginators({id: this.item.originator_id});
      this.smsTemplatesList = await this.actionGetSmsTemplates({id: this.item.template_id});
    }
    // const resp = await this.actionGetPartners(this.params)
    // let existsPartner = !this.item.partner_id || resp.data.partners.some((partnerItem:any) => partnerItem.id === this.item.partner_id)
    // if (!existsPartner) {
    //   this.item.partner_id = undefined
    // }
  }

  get templatesByTransport() {
    switch (this.transport) {
      case MsgTransports.SMS:
        return <TemplateItem[]>this.smsTemplatesList ?? []
      case MsgTransports.CALL:
        return []
      default:
        return []
    }
  }

  back():void{
    this.$router.push(`/${this.transport.toLowerCase()}/priority_rules/`);
  }

  onSaveItem():Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      let valid:boolean = await this.validator.validate();
      if (valid) {
        try {
          this.logObject = {
            action_page: this.$route.meta.msgKey,
            action: this.$route.params.id ? "Editing" : "Creation",
            action_status: "success",
            object_type: "The rule for changing the priority of sending",
            addititional_info: getTranslatedParams(this.item)
          }
          let object = {
            item: this.item,
            transport: this.transport.toLowerCase()
          };
          await this.actionSave(object);
          await this.actionLog(this.logObject);
          this.itemSaved = this.item;
          resolve()
          this.back();
        } catch (error) {
          await this.actionLog({...this.logObject, action_status: "failed"});
          reject();
          notifyError(error);
        }
      } else {
        setTimeout(() => {
          notifyError(null, this.validator.errors)
        }, 100);
      }
    })
  }

  async onDeleteItem():Promise<void> {
    let isConfirm:boolean = await notifyDelete();
    if (isConfirm) {
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Removal",
          action_status: "success",
          object_type: "The rule for changing the priority of sending",
          addititional_info: getTranslatedParams({id: this.item.id})
        }
        let object = {
          item: this.item,
          transport: this.transport.toLowerCase()
        };
        await this.actionDelete(object);
        await this.actionLog(this.logObject);
        this.itemSaved = this.item;
        this.back();
      } catch (error) {
        await this.actionLog({...this.logObject, action_status: "failed"});
        notifyError(error);
      }
    }
  }

  public beforeLeave(to:any, from:any, next:any) {
    let isChange = !isEqual(this.item,this.itemSaved);
    notifyConfirm(isChange, this.onSaveItem, next);
  }

  @Watch('item.partner_id')
  onPartnerChanged(val?: number, oldVal?: number) {
    if (oldVal && val !== oldVal) {
      this.item.originator_id = null;
      this.item.template_id = null;
    }
  }
}
